import { Component } from "@angular/core";

@Component({
  selector: 'app-substituto-tributario-menu',
  templateUrl: './substituto-tributario-menu.component.html',
  styleUrls: ['./substituto-tributario-menu.component.scss']
})
export class SubstitutoTributarioMenuComponent {

}